export default "__VITE_ASSET__DBj_KaTx__"